import e from"@emotion/styled";import{setColor as t,setFontSize as i}from"../../utils/generateStyles.js";const r=e.div`
  label: checkbox;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  column-gap: 12px;
  ${o=>o.disabled&&{cursor:"default"}}
`,l=e.div`
  label: checkbox-icon;
  position: relative;
  border-radius: 2px;
  display: block;
  width: 16px;
  height: 16px;
  border-width: 1px;
  border-style: solid;
  ${o=>o.disabled&&{opacity:"0.6"}}
  ${()=>t("blue-50","borderColor")};
  ${o=>o.checked&&t("blue-50","backgroundColor")};
  ${o=>o.checked&&{["&:after"]:{content:'""',transform:"rotate(45deg)",position:"absolute",display:"block",width:"5px",height:"9px",left:"4px",top:0,right:"auto",bottom:"auto",borderWidth:"1px",borderStyle:"solid",borderColor:"#fff",borderTopWidth:0,borderLeftWidth:0}}}
`,d=e.div`
  label: checkbox-title;
  font-weight: 500;
  ${()=>i("xs")}
  ${()=>t("gray-black","color")};
  ${o=>o.disabled&&t("gray-90","color")}
`,a=e.div`
  display: none;
`;export{l as CheckboxIconStyled,a as CheckboxInputStyled,r as CheckboxStyled,d as CheckboxTitleStyled};
